import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { PrimaryButton } from '@zawarski/palmetto-ui-components';
import 'common/styles/common.css';
import '@zawarski/palmetto-ui-components/dist/styles/common.login.css';

import { LoginProps } from './Login.props';

const LoginView: React.FC<LoginProps> = ({ ...props }: LoginProps) => {
  const portalRedirect = (
    <>
      {props.loading && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            backgroundColor: 'rgb(128 128 128 / 31%)',
            zIndex: 99,
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          }}>
          <Stack rowGap={2}>
            <CircularProgress size={32} sx={{ mx: 'auto' }} />
            <Typography variant="body1" fontWeight={400} color="textSecondary">
              {'Verifying token...'}
            </Typography>
          </Stack>
        </Box>
      )}
      {!props.loading && (
        <div className="layout vertical center vertical-center full-height">
          <div className="layout vertical logincontainer">
            <div className="layout horizontal center center-justified app-logo-container">
              <img className="app-logo" src="/images/launcher.png" alt="Palmetto Logo" />
            </div>
            <div className="layout horizontal center-justified">
              <span className="app-title">{process.env.REACT_APP_APP_TITLE}</span>
            </div>
            <div
              style={{
                textAlign: 'center',
                height: '50px',
                paddingTop: '24px',
                color: 'rgba(0,0,0,67)',
                fontSize: '14px'
              }}>
              Please use the Portal to access this site.
            </div>
            <div className="layout horizontal center-justified">
              <PrimaryButton
                className="flex login-btn"
                style={{ maxWidth: '220px' }}
                onClick={() => {
                  window.location.href = 'https://portal.palmettoeoc.com';
                }}>
                NAVIGATE TO PORTAL
              </PrimaryButton>
            </div>
            <div
              style={{
                textAlign: 'center',
                paddingLeft: '64px',
                paddingRight: '64px',
                paddingTop: '44px',
                color: 'rgba(107,107,107,30)',
                fontSize: '14px'
              }}>
              Access to this site is now available only through the portal on the following link:{' '}
            </div>
            <div
              style={{ fontSize: '16px', paddingTop: '4px' }}
              className="layout horizontal center-justified">
              <a target="_blank" rel="noopener noreferrer" href="https://portal.palmettoeoc.com">
                portal.palmettoeoc.com
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
  return portalRedirect;
};

export default LoginView;
